import React, { createContext, useContext, useState, useEffect } from 'react';
import useAuthStore from '../store/authStore';

const EditorContext = createContext();

export const EditorProvider = ({ children }) => {
  const [isEditorMode, setIsEditorMode] = useState(false);
  const [selectedElement, setSelectedElement] = useState(null);
  const [pageContent, setPageContent] = useState({});
  const user = useAuthStore(state => state.user);
  
  const isAdmin = user?.role === 'admin';

  const toggleEditorMode = () => {
    if (isAdmin) {
      setIsEditorMode(!isEditorMode);
      if (isEditorMode) {
        setSelectedElement(null);
      }
    }
  };

  const selectElement = (elementId, elementType, currentContent) => {
    if (isEditorMode) {
      setSelectedElement({
        id: elementId,
        type: elementType,
        content: currentContent
      });
    }
  };

  const updateContent = (pageId, elementId, contentType, content) => {
    setPageContent(prev => ({
      ...prev,
      [pageId]: {
        ...prev[pageId],
        [elementId]: {
          contentType,
          content
        }
      }
    }));
  };

  return (
    <EditorContext.Provider
      value={{
        isEditorMode,
        isAdmin,
        toggleEditorMode,
        selectedElement,
        selectElement,
        setSelectedElement,
        pageContent,
        updateContent
      }}
    >
      {children}
    </EditorContext.Provider>
  );
};

export const useEditor = () => {
  const context = useContext(EditorContext);
  if (!context) {
    throw new Error('useEditor must be used within EditorProvider');
  }
  return context;
};
